import React from "react";
import "./style.scss";

const OptionButtons = ({ selected, onSelect, notApplicable, responseType }) => {
  const isYesSelected = selected === "Yes";
  const text = (responseType?.split("applicable ")?.[1] || responseType?.split("Applicable ")?.[1])?.split("+ Text")?.[0]

  return (
    <div className={`options__btn ${notApplicable ? "not__applicable" : ""}`}>
      <button
        className={`option__btn ${isYesSelected ? "selected" : ""}`}
        onClick={() => onSelect("Yes")}
      >
        Yes
      </button>
      <button
        className={`option__btn ${selected === "No" ? "selected" : ""}`}
        onClick={() => onSelect("No")}
      >
        No
      </button>
      {notApplicable ? (
         <div>
          <button
            className={`option__btn w-100 ${
              selected === "Not Applicable" ? "selected" : ""
            }`}
            onClick={() => onSelect("Not Applicable")}
            style={{paddingLeft:15, paddingRight:15}}
          >
            Not Applicable
            <br />
            <span style={{fontSize:16, textTransform:"capitalize"}}>{text}</span>
          </button>
         </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default OptionButtons;
